import React, { Component } from 'react';
import { Auth, API, JS } from 'aws-amplify';
import { withStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Link from '@material-ui/core/Link';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import { withSnackbar } from 'hooks/useSnack';
import Cookies from 'universal-cookie';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

const FormItem = Form.FormItem;

const styles = (theme) => ({
  root: {
    maxWidth: 460,
    margin: '15px auto 30px',
    '& .MuiFormControl-root': {
      marginBottom: theme.spacing(1.5),
    },
    '& .MuiButton-sizeLarge': {
      padding: '15px 22px'
    }
  },
  title: {
    marginBottom: theme.spacing(1.5),
    fontSize: 14
  },
});

const cookies = new Cookies();

const normalizeEmail =  (v, prev) => {
  if (v === prev) {
    return v;
  }
  return v.trim();
}

class CustomSignIn extends Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.signIn = this.signIn.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmission = this.handleFormSubmission.bind(this);
    this.state = {
      showResendCode: false,
      passwordSent: false,
    };
  }

  handleFormSubmission(evt) {
    evt.preventDefault();
    cookies.set('onboarding_skip', false);
    return this.props.form.validateFields().then(this.signIn);
  }

  checkContact(user) {
    Auth.verifiedContact(user).then((data) => {
      if (!JS.isEmpty(data.verified)) {
        this.props.onStateChange('signedIn', user);
      } else {
        user = Object.assign(user, data);
        this.props.onStateChange('verifyContact', user);
      }
    });
  }

  async signIn({ username, password }) {
    const { onStateChange } = this.props;
    try {
      const user = await Auth.signIn(username, password);
      if (
        user.challengeName === 'SMS_MFA' ||
        user.challengeName === 'SOFTWARE_TOKEN_MFA'
      ) {
        this.props.onStateChange('confirmSignIn', user);
      } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.props.onStateChange('requireNewPassword', user);
      } else if (user.challengeName === 'MFA_SETUP') {
        this.props.onStateChange('TOTPSetup', user);
      } else if (
        user.challengeName === 'CUSTOM_CHALLENGE' &&
        user.challengeParam &&
        user.challengeParam.trigger === 'true'
      ) {
        this.props.onStateChange('customConfirmSignIn', user);
      } else {
        this.checkContact(user);
      }
    } catch (err) {
      console.log(err);
      if (err.message.includes('Temporary password has expired')) {
        this.setState({
          showResendCode: true,
        });
      } else {
        this.props.snackbar.error(err.message);
        if (err.code === 'UserNotConfirmedException') {
          this.props.updateUsername(username);
          await Auth.resendSignUp(username);
          this.props.onStateChange('confirmSignUp', {});
        } else if (err.code === 'PasswordResetRequiredException') {
          onStateChange('forgotPassword', { username });
        } else if (err.code === 'NotAuthorizedException') {
          // The error happens when the incorrect password is provided
          this.setState({ error: 'Login failed.' });
        } else if (err.code === 'UserNotFoundException') {
          // The error happens when the supplied username/email does not exist in the Cognito user pool
          this.setState({ error: 'Login failed.' });
        } else {
          this.setState({ error: 'An error has occurred.' });
          console.error(err);
        }
      }
    }
  }

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    this.setState({ error: '' });
  }

  onReset = (e) => {
    e.preventDefault();
    this.setState({
      showResendCode: false,
      passwordSent: false,
    });
    this.props.onStateChange('forgotPassword', {});
  };

  sendPassword = async () => {
    const username = this.props.form.getFieldValue('username');
    try {
      await API.post('public', `/users/reset_password`, {
        body: {
          username,
        },
      });
      const resp = await Auth.forgotPassword(username);
      this.setState({
        username,
        passwordSent: true,
        delivery: resp.CodeDeliveryDetails,
      });
      this.props.snackbar.success('Password successfully updated.');
    } catch (e) {
      this.props.snackbar.error(
        e.response ? e.response.data.message : e.message,
      );
    }
  };

  handleSetPassword = () => {
    const { snackbar } = this.props;
    const { username } = this.state;
    return this.props.form.validateFields().then(async (values) => {
      try {
        await Auth.forgotPasswordSubmit(username, values.code, values.password);
        this.setState({
          showResendCode: false,
          passwordSent: false,
        });
      } catch (e) {
        snackbar.error(e.message);
      }
    });
  };

  renderSetPassword = () => {
    const { classes, form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Card className={classes.root}>
        <CardContent>
          <Typography className={classes.title} variant="subtitle2">
            Set your password
          </Typography>
          <Alert color="success">
            Verification Code has been sent to your registered email address.
          </Alert>
          <br />
          <Form>
            <FormItem>
              {getFieldDecorator('code', {
                rules: [{ required: true }],
              })(<Input label="Code" />)}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true }],
              })(<Input disableMargin label="Password" type="password" />)}
            </FormItem>
            <Box textAlign="right" marginTop={3}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={this.handleSetPassword}
              >
                SET PASSWORD
              </Button>
            </Box>
          </Form>
        </CardContent>
      </Card>
    );
  };

  render() {
    const { showResendCode, passwordSent } = this.state;
    const { form, classes, authState } = this.props;
    const { getFieldDecorator } = form;

    if (authState !== 'signIn') return null;

    if (passwordSent) return this.renderSetPassword();

    return (
      <Box className={classes.root}>
        <CardContent>
          <Typography className={classes.title}>
            Sign in to your account
          </Typography>
          <Form onSubmit={this.handleFormSubmission}>
            {showResendCode && !passwordSent && (
              <Alert style={{ marginBottom: 24 }} icon={false} color="error">
                <Typography gutterBottom variant="body2" color="inherit">
                  Your temporary password has expired. Please click{' '}
                  <strong>Reset Password</strong> to request a new password.
                </Typography>
                <Button
                  onClick={this.sendPassword}
                  color="secondary"
                  variant="outlined"
                >
                  Reset Password
                </Button>
              </Alert>
            )}
            {passwordSent && (
              <Alert color="success" style={{ marginBottom: 24 }}>
                Temporary password has been sent to your registered email
                address.
              </Alert>
            )}
            <FormItem>
              {getFieldDecorator('username', {
                normalize: normalizeEmail,
                rules: [{ required: true }],
              })(<Input placeholder="Username" />)}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true }],
              })(<Input disableMargin placeholder="Password" type="password" />)}
            </FormItem>
            <Box>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={this.handleFormSubmission}
              >
                Sign in
              </Button>
            </Box>
          </Form>
        </CardContent>
        <Box marginTop={2}>
          <Box marginBottom={.6}>
            <Typography
              
            >
              Don’t have an account? <Link href='https://www.weadmit.com/registration'>Create account</Link>
            </Typography>
          </Box>
          <Typography>
            <Link href="#" onClick={this.onReset}>
              Forgot password?
            </Link>
          </Typography>
        </Box>
      </Box>
    );
  }
}

export default Form.create()(withStyles(styles)(withSnackbar(CustomSignIn)));
